import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Table, Collapse, Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label } from 'reactstrap';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import './RiskMap.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { FaChevronUp, FaChevronDown, FaMapMarkerAlt, FaSlash, FaDrawPolygon, FaRegCircle, FaRegSquare, FaTrash } from 'react-icons/fa';
import uuid from 'react-uuid';
import MapView from '../Map/MapView';
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const RiskSummary = () => {
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId")); const [itemList, setItemList] = useState([]);
    const [loading, setLoading] = useState(true); const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0 })
    const [biodiversity, setBiodiversity] = useState({ outlineList: [], itemList: [], SectionName: 'Risk Summary', Section: 'Risk Summary', isWizardCompleted: false, sectionObj: {} });
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false, isFarmOutlineEditable: false, zoomLevel: 15,
        polytype: '', itemsEditable: false, highlighteditemId: 0
    }); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [sectionList, setSectionList] = useState([]);
    const [tempItemList, setTempItemList] = useState([]);
    const [riskSummary, setRiskSummary] = useState([]);
    const [isOpen, setIsOpen] = useState(true);
    const [isIconUp, setIsIconUp] = useState(false);
    const [reasonPopup, setReasonPopup] = useState({ showReasonPopup: false, reason: '', reasonItemId: 0, mode: '' });
    const [showRemoveOptOutValidation, setShowRemoveOptOutValidation] = useState(false);
    const [showRemoveCustomRiskValidation, setShowRemoveCustomRiskValidation] = useState(false);
    const [showRemoveCustomRiskValidationItem, setShowRemoveCustomRiskValidationItem] = useState({});
    const [formDocumentErrors, setFormDocumentErrors] = useState({});

    const toggle = () => {
        setIsOpen(!isOpen);
        setIsIconUp(!isIconUp);
    };

    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/RiskSummary/GetRiskSummary/', {
                params: {
                    farmId: farmId
                }
            }
            );
            setBiodiversity({
                ...biodiversity, outlineList: response.data.outlineList, itemList: response.data.riskItemList, isWizardCompleted: response.data.isFWFPCompleted, sectionObj: response.data.section
            });
            setItemList(response.data.riskItemList);
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel });
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList })
            setSectionList(response.data.myFarmSections);
            setTempItemList(response.data.riskItemList);
            setRiskSummary(response.data.riskSummary);
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    }

    const mapView = useMemo(() => {
        return (
            <MapView
                itemModel={biodiversity}
                mapDetails={mapDetails}
                largeEnterpriseDetails={largeEnterpriseDetails}>
            </MapView>
        )
    }, [biodiversity, mapDetails, largeEnterpriseDetails])

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const openReasonPopup = async (item,mode) => {
        setReasonPopup({ ...reasonPopup, showReasonPopup: true, reason: item.reason == null ? '' : item.reason, reasonItemId: item.id, mode: mode });
    }

    const closeReasonPopup = async () => {
        setReasonPopup({ ...reasonPopup, showReasonPopup: false,mode:''});
    }

    const openRemoveOptOutValidation = async () => {
        setShowRemoveOptOutValidation(true);
    }

    const confirmReasonPopup = async () => {
        setFormDocumentErrors({});
        const errors = {};
        if (reasonPopup.reason == null || reasonPopup.reason == "") {
            errors.reason = "Reason can not be blank!";
        }
        setFormDocumentErrors(errors);
        if (Object.keys(errors).length == 0) {
            const response = await apiGet(
                '/api/RiskSummary/UpdateReason/', {
                    params: {
                        id: reasonPopup.reasonItemId, reason: reasonPopup.reason, userId: userId, farmId: farmId
                }
            }
            );
            if (response.data.status) {
                setReasonPopup({ ...reasonPopup, showReasonPopup: false, mode: '' });
                toast.success("Reason updated!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setTimeout(() => {
                    window.location.reload(true);
                }, 1000);
            }
            else {
                toast.error("Error while updating reason", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }
    const handleReasonTextChange = (e) => {
        setReasonPopup({ ...reasonPopup, reason: e.target.value });
    };

    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    const closeRemoveOptOutValidation = async () => {
        setShowRemoveOptOutValidation(false);
    }

    const closeRemoveCustomRiskValidation = async () => {
        setShowRemoveCustomRiskValidation(false);
    }

    const saveRemoveOptOut = async () => {
        const response = await apiGet(
            '/api/RiskSummary/UpdateReason/', {
            params: {
                id: reasonPopup.reasonItemId, reason: null, userId: userId
            }
        }
        );
        if (response.data.status) {
            setReasonPopup({ ...reasonPopup, showReasonPopup: false, mode: '' });
            toast.success("Opt out reason is removed!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            setTimeout(() => {
                window.location.reload(true);
            }, 1000);
        }
        else {
            toast.error("Error while removing Opt out", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
    }

    const saveRemoveCustomRisk = async () => {
        const response = await apiGet(
            '/api/RiskSummary/RemoveCustomRisks/', {
            params: {
                    id: showRemoveCustomRiskValidationItem.riskId, userId: userId, farmId: farmId
            }
        }
        );
        if (response.data.status) {
            setShowRemoveCustomRiskValidation(false);
            toast.success("Custom risk removed!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            setTimeout(() => {
                window.location.reload(true);
            }, 1000);
        }
        else {
            toast.error("Error while removing custom risk", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
    }

    const openDeleteItemPopup = async (item) => {
        if (item.action_Improvement != 0 || item.action_Ongoing != 0) {
            toast.error("Unable to delete - only custom risks with no actions can be deleted!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        else {
            setShowRemoveCustomRiskValidationItem(item);
            setShowRemoveCustomRiskValidation(true);
        }
    }

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h2>{biodiversity.SectionName}</h2></Col>
            </Row>
            {
                loading ? <SpinnerContainer /> :
                    <div>
                        <Row style={{ marginTop: '10px' }}>
                            <Col id='mapView'>
                                {mapView}
                            </Col>
                            <Col id='nonMapView'>
                                <Card>
                                    <CardHeader className="header">
                                        <Row>
                                            <Col sm="6"><span className="text-uppercase fw-bold color-dark-teal">List of Risks</span></Col>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col>
                                                <p>The list of risk below includes the default list of Farming Activity Risks, plus Inherent Vulnerability and Items added to different layers of the map which have been marked as risk.</p>
                                                
                                                <p>Note which risks have actions against them – if any risks do not have actions it may be an opportunity to return and add more actions, otherwise if a particular activity risk is not applicable please outline the reason why and it will be removed.</p>
                                            </Col>
                                        </Row>
                                        <Row className="my-3">
                                            <Col>
                                                <Card className="card-header-outline">
                                                    <CardHeader className="item-header card-header-click" onClick={toggle}>
                                                        <Row>
                                                            <Col sm="11">
                                                                <h5>Risks</h5>
                                                            </Col>
                                                            <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                                        </Row>
                                                    </CardHeader>
                                                    <Collapse isOpen={isOpen}>
                                                        <CardBody style={{ maxHeight: "500px", overflowY:"auto"}}>
                                                            <Row className="my-3">
                                                                <Col>
                                                                    <Table bordered style={{ tableLayout: 'fixed', width: '100%' }}>
                                                                        <thead style={{ background: 'darkgrey' }}>
                                                                            <tr>
                                                                                <th rowSpan="2" style={{ width: '40%', verticalAlign: 'middle' }}> Activity Risks </th>
                                                                                <th colSpan="2" style={{ width: '30%', textAlign: 'center' }}> #Actions </th>
                                                                                <th rowSpan="2" style={{ width: '30%', verticalAlign: 'middle', textAlign: 'center' }}> Risk Options </th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th style={{ width: '20%', textAlign: 'center' }}> Improvement </th>
                                                                                <th style={{ width: '20%', textAlign: 'center' }}> Ongoing </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody >
                                                                            {
                                                                                riskSummary != undefined && riskSummary.filter(x => x.riskType == 'Activity Risks').map(item =>
                                                                                    <tr key={item.id} style={{ background: item.reason != null ? 'lightgray' : '' }}>
                                                                                        <td> {item.riskName} </td>
                                                                                        <td style={{ textAlign: 'center' }}> {item.action_Improvement == 0 ? "" : item.action_Improvement} </td>
                                                                                        <td style={{ textAlign: 'center' }}> {item.action_Ongoing == 0 ? "" : item.action_Ongoing} </td>
                                                                                        <td style={{ textAlign: 'center' }}>
                                                                                            {item.reason != null && (item.action_Improvement == 0 && item.action_Ongoing == 0) && <Button type="button" style={{ background: "none", color: "blue", border: "none" }}
                                                                                                id="btnUpdate"
                                                                                                className="btn btn-sm"
                                                                                                onClick={() => openReasonPopup(item,'Edit')}>Risk has been opted out
                                                                                            </Button>}
                                                                                            {item.reason == null && (item.action_Improvement == 0 && item.action_Ongoing == 0) && <Button type="button" style={{ background: "none", color: "blue", border: "none" }}
                                                                                                id="btnUpdate"
                                                                                                className="btn btn-sm"
                                                                                                onClick={() => openReasonPopup(item,'New')}>Opt out of this risk
                                                                                            </Button>}
                                                                                            {
                                                                                                item.customRisk == true &&
                                                                                                <Button type="button" color="danger"
                                                                                                id="btnUpdate"
                                                                                                className="btn btn-sm"
                                                                                                onClick={() => openDeleteItemPopup(item)}><FaTrash  /> Remove Custom Risk
                                                                                            </Button>
                                                                                            }
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                        </tbody>
                                                                    </Table>
                                                                    <Table bordered style={{ tableLayout: 'fixed', width: '100%', marginTop: '-17px' }}>
                                                                        <thead style={{ background: 'darkgrey' }}>
                                                                            <tr>
                                                                                <th style={{ width: '40%', verticalAlign: 'middle' }}> Inherent Risks</th>
                                                                                <th colSpan="2" style={{ width: '30%', textAlign: 'center' }}> #Actions </th>
                                                                                <th style={{ width: '30%', verticalAlign: 'middle' }}> </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody >
                                                                            {
                                                                                riskSummary != undefined && riskSummary.filter(x => x.riskType == 'Inherent Risks').map(item =>
                                                                                    <tr key={item.id} style={{ background: item.reason != null ? 'lightgray' : '' }}>
                                                                                        <td> {item.riskName} </td>
                                                                                        <td style={{ textAlign: 'center' }}> {item.action_Improvement == 0 ? "" : item.action_Improvement} </td>
                                                                                        <td style={{ textAlign: 'center' }}> {item.action_Ongoing == 0 ? "" : item.action_Ongoing} </td>
                                                                                        <td style={{ textAlign: 'center' }}> {item.reason != null && (item.action_Improvement == 0 && item.action_Ongoing == 0) && <Button type="button" style={{ background: "none", color: "blue",border:"none" }}
                                                                                            id="btnUpdate"
                                                                                            className="btn btn-sm"
                                                                                            onClick={() => openReasonPopup(item, 'Edit')}>Risk has been opted out
                                                                                        </Button>}
                                                                                            {item.reason == null && (item.action_Improvement == 0 && item.action_Ongoing == 0) && <Button type="button" style={{ background: "none", color: "blue",border:"none" }}
                                                                                                id="btnUpdate"
                                                                                                className="btn btn-sm"
                                                                                                onClick={() => openReasonPopup(item, 'New')}>Opt out of this risk
                                                                                            </Button>} </td>
                                                                                    </tr>
                                                                                )}
                                                                        </tbody>
                                                                    </Table>
                                                                    <Table bordered style={{ tableLayout: 'fixed', width: '100%', marginTop: '-17px' }}>
                                                                        <thead style={{ background: 'darkgrey' }}>
                                                                            <tr>
                                                                                <th style={{ width: '40%', verticalAlign: 'middle' }}> Item Risks</th>
                                                                                <th colSpan="2" style={{ width: '30%', textAlign: 'center' }}> #Actions </th>
                                                                                <th style={{ width: '30%', verticalAlign: 'middle' }}> </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody >
                                                                            {
                                                                                riskSummary != undefined && riskSummary.filter(x => x.riskType == 'Item Risks').map(item =>
                                                                                    <tr key={item.id} style={{ background: item.reason != null ? 'lightgray' : '' }}>
                                                                                        <td>
                                                                                            <a onMouseOver={(itemId) => handleItemHighlight(item.riskId)} onMouseOut={(itemId) => handleItemHighlight(0)}>
                                                                                                {item.mapMarkerType == 'marker' ? <FaMapMarkerAlt color={item.colour}></FaMapMarkerAlt> :
                                                                                                    item.mapMarkerType == 'polyline' ? <FaSlash color={item.colour}></FaSlash> :
                                                                                                        item.mapMarkerType == 'polygon' ? <FaDrawPolygon color={item.colour}></FaDrawPolygon> :
                                                                                                            item.mapMarkerType == 'circle' ? <FaRegCircle color={item.colour}></FaRegCircle> :
                                                                                                                item.mapMarkerType == 'rectangle' && <FaRegSquare color={item.colour}></FaRegSquare>}
                                                                                            </a>&nbsp;&nbsp;&nbsp;
                                                                                            {item.riskName} </td>
                                                                                        <td style={{ textAlign: 'center' }}> {item.action_Improvement == 0 ? "" : item.action_Improvement} </td>
                                                                                        <td style={{ textAlign: 'center' }}> {item.action_Ongoing == 0 ? "" : item.action_Ongoing} </td>
                                                                                        <td style={{ textAlign: 'center' }}> {item.reason != null && (item.action_Improvement == 0 && item.action_Ongoing == 0) && <Button type="button" style={{ background: "none", color: "blue",border:"none" }}
                                                                                            id="btnUpdate"
                                                                                            className="btn btn-sm"
                                                                                            onClick={() => openReasonPopup(item, 'Edit')}>Risk has been opted out
                                                                                        </Button>}
                                                                                            {item.reason == null && (item.action_Improvement == 0 && item.action_Ongoing == 0) && <Button type="button" style={{ background: "none", color: "blue",border:"none" }}
                                                                                                id="btnUpdate"
                                                                                                className="btn btn-sm"
                                                                                                onClick={() => openReasonPopup(item, 'New')}>Opt out of this risk
                                                                                            </Button>} </td>
                                                                                    </tr>
                                                                                )}
                                                                        </tbody>
                                                                    </Table>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Collapse>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Modal isOpen={reasonPopup.showReasonPopup}>
                                    <ModalHeader>Please provide a reason for opting out of this risk. Once opted out this risk will no longer be able to be selected by an action</ModalHeader>
                                    <ModalBody>
                                        <Row>
                                            <Col>
                                                <FormGroup>
                                                    <Label style={{ textTransform: "math-auto" }}>Reason</Label>
                                                    <textarea name="reason"
                                                        value={reasonPopup.reason}
                                                        onChange={handleReasonTextChange}
                                                        className="form-control"></textarea>
                                                </FormGroup>
                                                {formDocumentErrors.reason != undefined &&
                                                    <p className="errorMessage">{formDocumentErrors.reason}</p>
                                                }
                                            </Col>
                                        </Row>
                                    </ModalBody>
                                    <ModalFooter>
                                        {reasonPopup.mode == 'Edit' && <Button color="primary" onClick={openRemoveOptOutValidation}>Remove Opt out</Button>}
                                        <Button color="primary" onClick={confirmReasonPopup}>Save</Button>
                                        <Button color="danger" onClick={closeReasonPopup}>Cancel</Button>
                                    </ModalFooter>
                                </Modal>
                                <Modal isOpen={showRemoveOptOutValidation}>
                                    <ModalHeader>Remove Opt out</ModalHeader>
                                    <ModalBody>
                                        This will re-activate the risk and remove the opt-out reason. Are you sure you wish to continue?
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="primary" onClick={saveRemoveOptOut}>Yes</Button>
                                        <Button color="danger" onClick={closeRemoveOptOutValidation}>No</Button>
                                    </ModalFooter>
                                </Modal>
                                <Modal isOpen={showRemoveCustomRiskValidation}>
                                    <ModalHeader>Remove Custom Risk</ModalHeader>
                                    <ModalBody>
                                        Are you sure to delete the custom risk?
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="primary" onClick={saveRemoveCustomRisk}>Yes</Button>
                                        <Button color="danger" onClick={closeRemoveCustomRiskValidation}>No</Button>
                                    </ModalFooter>
                                </Modal>
                            </Col>
                        </Row>
                    </div>

            }
            

        </div>
    )
}
export default RiskSummary;